import React, { useState } from 'react'
import { Card, CardContent, CardHeader, IconButton, Tooltip } from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import PhoneIcon from '@mui/icons-material/Phone'
import MaterialTable from '../../../../common/MaterialTable'
import { getDDMMYYYYHHmmToIST } from '../../../../helpers/UtilityHelper'
import FakeNDRWhatsAppConversation from './FakeNDRWhatsAppConversation'

const FakeDeliveryTable = ({ data = [] }) => {
    const [conversation, setConversation] = useState(null)
    const [conversationType, setConversationType] = useState('w')

    if (!data || data.length === 0) return null

    const handleWhatsApp = (item) => {
        if (item.whatsappconversationHistory && item.whatsappconversationHistory.length > 0) {
            setConversation(item.whatsappconversationHistory)
            setConversationType('w')
        }
    }

    const handleTelecalling = (item) => {
        if (item.futworksConversationHistory && item.futworksConversationHistory.length > 0) {
            const messages = item.futworksConversationHistory.flatMap((qa, i) => ([
                { id: `q_${i}`, action: 'message', messageValue: qa.question },
                { id: `a_${i}`, action: 'response', messageValue: qa.answer },
            ]))
            setConversation(messages)
            setConversationType('t')
        }
    }

    const columns = [
        { label: 'AWB Number', value: 'awbNumber', align: 'left' },
        { label: 'Courier', value: 'courierName', align: 'left' },
        { label: 'Status', value: 'orderStatus', align: 'left' },
        { label: 'Pickup Pincode', value: 'pickupPincode', align: 'left' },
        { label: 'Drop Pincode', value: 'dropPincode', align: 'left' },
        { label: 'Invoice Value', value: (row) => row.invoiceValue ? `\u20B9${row.invoiceValue}` : '-', align: 'right' },
        { label: 'Payment Mode', value: 'paymentMode', align: 'left' },
        { label: 'Order Date', value: (row) => getDDMMYYYYHHmmToIST(row.awbRegisteredDate), align: 'left' },
        {
            label: 'WhatsApp',
            value: 'whatsapp',
            align: 'center',
            tableValue: (row) => row.whatsappconversationHistory?.length > 0 ? (
                <Tooltip title="WhatsApp Conversation">
                    <IconButton size="small" sx={{ color: '#25D366' }} onClick={() => handleWhatsApp(row)}>
                        <WhatsAppIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            ) : null,
        },
        {
            label: 'Telecalling',
            value: 'telecalling',
            align: 'center',
            tableValue: (row) => row.futworksConversationHistory?.length > 0 ? (
                <Tooltip title="Telecalling History">
                    <IconButton size="small" sx={{ color: '#757575' }} onClick={() => handleTelecalling(row)}>
                        <PhoneIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            ) : null,
        },
    ]

    return (
        <>
            <Card elevation={1}>
                <CardHeader
                    title="Fake Delivery Details"
                    subheader="Shipments flagged as fake deliveries"
                />
                <CardContent>
                    <MaterialTable
                        size="small"
                        columns={columns}
                        rows={data}
                        fileName="FakeDeliveries"
                        frozenColumnsCount={1}
                    />
                </CardContent>
            </Card>
            {conversation && (
                <FakeNDRWhatsAppConversation
                    conversation={conversation}
                    setConversation={setConversation}
                    type={conversationType}
                />
            )}
        </>
    )
}

export default FakeDeliveryTable
